"use client"

import { useEffect, useState } from 'react'
import Image from 'next/image'

const CustomCursor = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 })
    const [isVisible, setIsVisible] = useState(true)
    const [isInteractive, setIsInteractive] = useState(false)
    const [isMobile, setIsMobile] = useState(true) // Default to true for SSR

    useEffect(() => {
        // Check if device is mobile
        const checkMobile = () => {
            const isMobileDevice = window.innerWidth < 768
            setIsMobile(isMobileDevice)
            // Only add custom cursor class if not mobile
            if (!isMobileDevice) {
                document.documentElement.classList.add('has-custom-cursor')
            } else {
                document.documentElement.classList.remove('has-custom-cursor')
            }
        }

        // Initial check
        checkMobile()

        const updatePosition = (e: MouseEvent) => {
            setPosition({ x: e.clientX, y: e.clientY })
            // Check if hovering an interactive element (links, buttons, clickable elements)
            const target = e.target as HTMLElement | null
            if (target) {
                const interactive = target.closest('a, button, [role="button"], [href], .cursor-pointer')
                setIsInteractive(!!interactive)
            }
        }

        const handleMouseEnter = () => setIsVisible(true)
        const handleMouseLeave = () => setIsVisible(false)

        // Only add event listeners if not mobile
        if (!isMobile) {
            document.addEventListener('mousemove', updatePosition, { passive: true })
            document.addEventListener('mouseenter', handleMouseEnter)
            document.addEventListener('mouseleave', handleMouseLeave)
        }

        // Handle resize events
        window.addEventListener('resize', checkMobile)

        return () => {
            document.documentElement.classList.remove('has-custom-cursor')
            document.removeEventListener('mousemove', updatePosition)
            document.removeEventListener('mouseenter', handleMouseEnter)
            document.removeEventListener('mouseleave', handleMouseLeave)
            window.removeEventListener('resize', checkMobile)
        }
    }, [isMobile])

    // Don't render on mobile
    if (isMobile) return null

    return (
        <div 
            id="custom-cursor"
            className="fixed pointer-events-none z-[9999] hidden md:block"
            style={{
                left: `${position.x}px`,
                top: `${position.y}px`,
                transform: 'translate(-50%, -50%)',
                willChange: 'transform',
                opacity: isVisible ? 1 : 0,
            }}
        >
            <div className="relative w-8 h-8">
                <Image 
                    src="/tik.svg" 
                    alt="cursor" 
                    width={32}
                    height={32}
                    className={`w-[32px] h-[32px] object-contain custom-cursor-img ${isInteractive ? 'interactive' : ''}`}
                    priority
                />
            </div>
        </div>
    )
}

export default CustomCursor 